import { Component } from '@angular/core';
import { BlogService } from '../../../services/blog.service';

declare var $: any;

@Component({
  selector: 'app-blog-area',
  templateUrl: './blog-area.component.html',
  styleUrl: './blog-area.component.scss'
})
export class BlogAreaComponent {

  blogs: any[] = [];
  constructor(private blogService: BlogService) { }

  ngOnInit(): void {
    this.blogService.getBlogs(1, 3).subscribe({
      next: (data) => this.blogs = data.data,
      error: (err) => console.error('Failed to load blog data:', err)
    });
  }
  onImageError(event: any): void {
    event.target.src = '/assets/img/noimage.png';
  }
}
